import React, { useState, useEffect } from 'react';
import { formatMoneda } from '../../../util/varios';
import { TableBody, TableRow, TableCell, InputAdornment } from '@mui/material'

;

import useTableFijo from "../../useTableFijo"
import moment from 'moment';

const Tablahtpp = props => {

    let op = require('../../../../src/modulos/datos');



    const [records, setRecords] = useState([]);

    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    const headCells = [
        { id: '', label: 'AÑO', width: '10px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white", disableSorting: true },
        { id: '', label: 'MES', width: '80px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white", disableSorting: true },
        { id: '', label: 'UBICACIÓN', width: '200px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white", disableSorting: true },
        { id: '', label: 'MONTO', width: '80px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white", disableSorting: true },
        { id: '', label: 'NRO.RECIBO', width: '80px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white", disableSorting: true },
        { id: '', label: 'FECHA DE PAGO', width: '80px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white", disableSorting: true },
    ]

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTableFijo(records, headCells, filterFn, 220);


    useEffect(() => {

        
        if (props.tabhistoy) {

    
            setRecords(props.tabhistoy);
        }


    }, [props.tabhistoy]);

    const imprimirHistory = (reporte) => (event) => {
        event.preventDefault();
        var idcomercio = "codigo="+parseInt(props.idcomercio);
        reporte = 'HisPago_Publicid';
        window.open(op.reportes + "/propagandapublicidad?reporte=" + reporte + "&sql=" + idcomercio ,"Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");

    }

    return (
        <div className="card">
            <div class="card-header">
                <div className="row col-md-12" style={{ fontFamily: 'Times New Roman, Times, serif', fontSize: '15px' }}>
                    <div className="container row col-md-11 mx-auto">
                        <div className="col-md-2 ml-auto">
                            <button type="button" onClick={imprimirHistory('HisPago_Publicid')} class="btn btn-primary btn-sm rounded-circle"><i className="fas fa-print"> </i> </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card-body">
                <div className="content" >
                    <div className="container">
                        <div className="row col-md-12">
                            <div className="container" >
                                <div className="col-md-12">
                            <TblContainer container={{ height: 250, width: '100%', overflow: 'auto', padding: '2px' }} >
                                
                                        <TblHead />

                                        <tbody>
                                            {

                                                records && records.map((item, index) => (
                                                    <tr key={item.anio + item.mes} style={{ padding: "0" }}>
                                                        <td style={{ fontSize: "10px", textAlign: "left" }}>{item.anio}</td>
                                                        <td style={{ fontSize: "10px", textAlign: "left" }}>{item.mes}</td>
                                                        <td style={{ fontSize: "10px", textAlign: "center" }}>{item.ubicacion}</td>
                                                        <td style={{ fontSize: "10px", textAlign: "right" }}>{formatMoneda(item.monto.toString().replace('.', ','), ',', '.', 2)}</td>
                                                        <td style={{ fontSize: "10px", textAlign: "center" }}>{item.numerorecibo}</td>
                                                        <td style={{ fontSize: "10px", textAlign: "center" }}>{moment.utc(item.fechapago).format('DD-MM-YYYY')}</td>
                                                    </tr>

                                                ))
                                            }
                                        </tbody>

                                    </TblContainer>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );

}

export default Tablahtpp;
